import { render, staticRenderFns } from "./DividendHelpModal.vue?vue&type=template&id=9e155a44&"
import script from "./DividendHelpModal.vue?vue&type=script&lang=js&"
export * from "./DividendHelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports